<template>
  <!-- Change this to show only comment box when there is an actual comment or when add-comment-button is clicked -->
  <transition
    name="slide-top"
    tag="div"
    mode="out-in">
    <div class="container comment-section">
      <div class="comment-card" :style="{backgroundColor: $store.getters.clientStyle.primary}">
        <span class="icon upload-icon" :style="{color: $store.getters.clientStyle.primary}">
          <i class="fas fa-paperclip"></i>
        </span>
        <div class="upload-text">
          {{ upload.name }}

          <span class="icon is-pulled-right remove-icon" :style="{backgroundColor: $store.getters.clientStyle.primary}">
            <i class="fas fa-times" style="cursor: pointer;" @click="deleteDropFile(index)"></i>
          </span>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  inject: ['question', 'comment', 'uploads'],
  // created () {
  //   console.log(this.question)
  //   console.log(this.comment)
  // },
  props: {
    upload: File,
    index: Number
  },
  methods: {
    deleteDropFile(index) {
      // console.log(index);
      
      this.uploads.splice(index, 1)
      // call API to remove file from server
      
    }
  }
}
</script>

<style scoped>

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-top-enter-active {
  transition: all .2s ease;
  transition-delay: 0.5s;

}
.slide-top-leave-active {
  transition: all 0.1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-top-enter, .slide-top-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
.slide-top-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.comment-section {
  max-width: 980px;
  margin-top: 50px;
}

.comment-card {
  margin-top: -35px;
  border-radius: 10px;
  box-shadow: 0 1px 30px rgba(0,0,0,0.06);
  color: white;
  padding-top: 33px;
  padding-bottom: 33px;
  /* border-right: 10px solid; */
  max-width: 400px;
  margin-left: auto;
  /* border-color: #808080; */
  /* height: 150px; */
  position: relative;
  padding: 10px 15px;
  transition: margin-top 0.3s, margin-right 0.3s, box-shadow 0.3s;
  transition-delay: 400ms;
  transition-timing-function: ease;
  
}

.comment-card-collapsed {
  margin-top: -125px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 1px 10px rgba(0,0,0,0.06);
  padding-top: 33px;
  padding-bottom: 33px;
  /* border-right: 10px solid; */
  max-width: 400px;
  margin-left: auto;
  margin-right: 20px;
  /* border-color: #808080; */
  /* height: 150px; */
  position: relative;
  padding: 10px;
  transition: margin-top 0.4s, margin-right 0.4s, box-shadow 0.4s;
  transition-delay: 400ms;
  transition-timing-function: ease;
}

.remove-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.upload-icon {
  position: absolute;
  font-size: 0.9rem;
  background-color: white;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  margin: -1px -5px;
}

.upload-text {
  margin-left: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/UploadBox.vue